import React, { useEffect, useState } from "react";
import MembershipCard from "./MembershipCard";
import { Modal } from "./ui";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentMembership } from "../redux/actions/processAction";
import Footer from "./common/Footer";
import { GetMembershipList } from "../api/common";
import { useLocation, useNavigate } from "react-router-dom";
import Loading from "./ui/Loading";

export default function Membership() {
  const dispatch = useDispatch();
  const {pathname} = useLocation();
  const navigate = useNavigate();
  const [membershipList, setData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedMembership, setSelectedMembership] = useState(null);
  const [modalData, setModalData] = useState({
    eligibility : [],
    remark : "",
  });
  const [loading, setLoading] = useState(false);
  const [termCheck, setTermCheck] = useState(false);
  const {data} = useSelector((state) => state.process);

  const handleCardClick = (data) => {
    setSelectedMembership(data);
  };

  const handleOpenTerms = (data) => {
    setModalData({
      eligibility : data.eligibility.split(","),
      remark : data.eligibility_remark
    });
    setIsModalOpen(true); 
  }

  const handleCloseModal = () => {
    setTermCheck(false);
    setIsModalOpen(false);
  };

  const getData = async () =>{
    setLoading(true);
    try {
      const res = await GetMembershipList();

      if(res.status === 200){
        const respData = res.data.data;
        setData(respData);
        if(respData.length > 0){
          setSelectedMembership(respData[0]);
          setModalData({
            eligibility : respData[0].eligibility.split(","),
            remark : respData[0].eligibility_remark
          });
        }
      }
    } catch (error) {
      console.log(error);
    }finally{
      setLoading(false);
    }
  }

  const getDataUpgrade = async () =>{
    setLoading(true);
    if(!data.membership_id){
      return;
    }
    try {
      const res = await GetMembershipList(data.membership_id);

      if(res.status === 200){
        const respData = res.data.data;
        setData(respData);
        if(respData.length > 0){
          setSelectedMembership(respData[0]);
          setModalData({
            eligibility : respData[0].eligibility.split(","),
            remark : respData[0].eligibility_remark
          });
        }
      }
    } catch (error) {
      console.log(error);
    }finally{
      setLoading(false);
    }
  }

  useEffect(() =>{
    if(pathname.includes("upgrade")){
      getDataUpgrade();
    }else{
      getData();
    }
  }, [data.membership_id]); // eslint-disable-line


  const handleGoToNext = () => {
    if(termCheck){
      handleCloseModal();
      dispatch(setCurrentMembership(selectedMembership));
      if(pathname.includes("upgrade")){
        navigate("/app/upgrade/membership-form", { replace: true });
      }else{
        navigate("/register/user/membership-form", { replace: true });
      }
    }else{
      setIsModalOpen(true);
    }
  };  

  return (
    <>
      {loading && <Loading />}
      <div className="customContainer">
        <div className="headingTexts">
          <h2>Select the type of membership</h2>
          <p>
            Please select the membership that you want to register yourself
            under. Go through and confirm that you have read the eligibility
            criteria before proceeding with the next steps.
          </p>
        </div>

        <div className="row mt-5">
          {membershipList.map((data, index) => (
            <div className="col-md-6 col-lg-4" key={index}>
              <MembershipCard
                data={data}
                isActive={data.id === selectedMembership?.id}
                isChecked={data.id === selectedMembership?.id}
                onSelect={() => handleCardClick(data)}
                onTermClick={()=> handleOpenTerms(data)}
              />
            </div>
          ))}
        </div>
      </div>
      <Footer  
        isBackAllowed={true}
        isNextAllowed={selectedMembership !== null}
        nextButtonText="Continue"
        nextButtonAction={handleGoToNext}
        backButtonAction={() => {
          if(pathname.includes("upgrade")){
            navigate("/app/plan-status", { replace: true });
          }else{
            navigate("/", { replace: true });
          }
        }}
      />
      {isModalOpen && 
      <Modal modalTitle="Eligibility" handleCloseModal={handleCloseModal} footerButton footerAction={() => {handleGoToNext()}} footerActionActive={termCheck}>
        <ul className="eligibilityList">
          {modalData.eligibility.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
        {modalData.remark && <p>
          * {modalData.remark}
        </p>}
        <div className="form-check form-check-inline">
          <input
            className="form-check-input"
            type="checkbox"
            id="inlineCheckbox1"
            value="option1"
            checked={termCheck}
            onChange={(e) => setTermCheck(e.target.checked)}
          />
          <label className="form-check-label" htmlFor="inlineCheckbox1">
            {" "}
            I confirm that I am eligible to apply for this membership
            category.
          </label>
        </div>
      </Modal>}
    </>
  );
}
